import React from "react";
import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: inline-block;
  ${space}
  ${layout}
`;

const TachometerFastSolidSVG: React.FunctionComponent<StyledProps> = (
  props
) => {
  return (
    <StyledContainer {...props}>
      <svg width="19px" height="19px" fill="none" viewBox="0 0 20 14">
        <path
          fill="#070B16"
          d="M10 0C4.722 0 .5 4.031.5 9a8.5 8.5 0 001.286 4.531c.165.313.528.469.891.469H17.29c.363 0 .726-.156.89-.469A8.527 8.527 0 0019.5 9c0-4.969-4.255-9-9.5-9zm5.377 5.469L11.78 10c.198.281.33.625.33 1s-.132.719-.297 1H8.153a1.976 1.976 0 01-.264-1c0-1.094.923-2 2.111-2 .165 0 .363.031.528.094l3.562-4.531a.856.856 0 011.122-.157c.363.25.429.719.165 1.063z"
        ></path>
      </svg>
    </StyledContainer>
  );
};

export default TachometerFastSolidSVG;
